import * as typeguards from '../../typeguards/index';

const EMPTY_DESCRIPTION = 'CODE DESCRIPTION FORTHCOMING';
const EMPTY_CODE = 'UNKNOWN';

type CodeDescription = {
  found: boolean;
  description: string;
};

export const getCode = (code: CMxAPI.MedicalCode) => {
  let codeStr = EMPTY_CODE;
  if (typeguards.isCPT(code)) {
    codeStr = code.procedure_code;
  } else if (typeguards.isICD(code)) {
    codeStr = code.diagnosis_code;
  } else if (typeguards.isModifier(code)) {
    codeStr = code.modifier_code;
  }
  return codeStr;
};

export const getArtifactDescripton = (
  code: CMxAPI.MedicalCode,
  descriptions?: CMxAPI.CodeResponse
): CodeDescription => {
  let found = false;
  let description = EMPTY_DESCRIPTION;
  const key = getCode(code);

  if (descriptions) {
    const def = descriptions[key] || false;
    if (def) {
      found = true;
      if (def.description !== null && def.description.length) {
        description = def.description;
      } else if (def.shortDescription !== null && def.shortDescription.length) {
        description = def.shortDescription;
      }
    }
  }
  return { found, description };
};
